// Module
var code = `<div id="stage-content">
  <div id="page-container"></div>
</div>
`;
// Exports
module.exports = code;